import styled from '@emotion/styled'

const ErrorBannerText = styled.div`
  background-color: ${props => props.theme.colors.bannerBackgroundError};
  color: ${props => props.theme.colors.error};
  padding: 1rem;
  border-radius: 1rem;
`

export default ErrorBannerText
